export const CHAT_GET_CONTACTS = "CHAT_GET_CONTACTS";
export const CHAT_GET_CONTACTS_SUCCESS = "CHAT_GET_CONTACTS_SUCCESS";
export const CHAT_GET_CONTACTS_FAILURE = "CHAT_GET_CONTACTS_FAILURE";

export const CHAT_GET_CONVERSATIONS = "CHAT_GET_CONVERSATIONS";
export const CHAT_GET_CONVERSATIONS_SUCCESS = "CHAT_GET_CONVERSATIONS_SUCCESS";
export const CHAT_GET_CONVERSATIONS_FAILURE = "CHAT_GET_CONVERSATIONS_FAILURE";

export const CHAT_CREATE_CONVERSATION = "CHAT_CREATE_CONVERSATION";
export const CHAT_CREATE_CONVERSATION_SUCCESS = "CHAT_CREATE_CONVERSATION_SUCCESS";
export const CHAT_CREATE_CONVERSATION_FAILURE = "CHAT_CREATE_CONVERSATION_FAILURE";

export const CHAT_GET_MESSAGES = "CHAT_GET_MESSAGES";
export const CHAT_GET_MESSAGES_SUCCESS = "CHAT_GET_MESSAGES_SUCCESS";
export const CHAT_GET_MESSAGES_FAILURE = "CHAT_GET_MESSAGES_FAILURE";

export const CHAT_SEND_MESSAGE = "CHAT_SEND_MESSAGE";
export const CHAT_SEND_MESSAGE_SUCCESS = "CHAT_SEND_MESSAGE_SUCCESS";
export const CHAT_SEND_MESSAGE_FAILURE = "CHAT_SEND_MESSAGE_FAILURE";

export const CHAT_RECEIVE_MESSAGE = "CHAT_RECEIVE_MESSAGE";

export const CHAT_SET_ACTIVE_CONVERSATION = "CHAT_SET_ACTIVE_CONVERSATION";

export const CHAT_TYPING_START = "CHAT_TYPING_START";
export const CHAT_TYPING_STOP = "CHAT_TYPING_STOP";

export const CHAT_USER_ONLINE = "CHAT_USER_ONLINE";
export const CHAT_USER_OFFLINE = "CHAT_USER_OFFLINE";

export const CHAT_MESSAGE_READ = "CHAT_MESSAGE_READ";

export const CHAT_ADD_REACTION = "CHAT_ADD_REACTION";
export const CHAT_REMOVE_REACTION = "CHAT_REMOVE_REACTION";
export const CHAT_REACTION_ADDED = "CHAT_REACTION_ADDED";
export const CHAT_REACTION_REMOVED = "CHAT_REACTION_REMOVED";

export const CHAT_EDIT_MESSAGE = "CHAT_EDIT_MESSAGE";
export const CHAT_MESSAGE_EDITED = "CHAT_MESSAGE_EDITED";

export const CHAT_DELETE_MESSAGE = "CHAT_DELETE_MESSAGE";
export const CHAT_MESSAGE_DELETED = "CHAT_MESSAGE_DELETED";

export const CHAT_UPLOAD_FILE = "CHAT_UPLOAD_FILE";
export const CHAT_UPLOAD_FILE_SUCCESS = "CHAT_UPLOAD_FILE_SUCCESS";
export const CHAT_UPLOAD_FILE_FAILURE = "CHAT_UPLOAD_FILE_FAILURE";

export const CHAT_LOAD_MORE_MESSAGES = "CHAT_LOAD_MORE_MESSAGES";
export const CHAT_LOAD_MORE_MESSAGES_SUCCESS = "CHAT_LOAD_MORE_MESSAGES_SUCCESS";
